import React from "react";

const IconDocs: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
    >
      <path
        d="M12.5391 6.91124H8.43751C8.06455 6.91124 7.70687 6.76168 7.44315 6.49545C7.17942 6.22922 7.03126 5.86814 7.03126 5.49164V1.35112C7.03126 1.31974 7.01892 1.28965 6.99694 1.26747C6.97496 1.24528 6.94516 1.23282 6.91408 1.23282H4.21877C3.72148 1.23282 3.24457 1.43224 2.89294 1.78721C2.54131 2.14218 2.34377 2.62362 2.34377 3.12563V12.5897C2.34377 13.0917 2.54131 13.5731 2.89294 13.9281C3.24457 14.2831 3.72148 14.4825 4.21877 14.4825H10.7813C11.2785 14.4825 11.7555 14.2831 12.1071 13.9281C12.4587 13.5731 12.6563 13.0917 12.6563 12.5897V7.02954C12.6563 6.99817 12.6439 6.96808 12.6219 6.94589C12.6 6.92371 12.5702 6.91124 12.5391 6.91124Z"
        fill="#4FD1C5"
      />
      <path
        d="M12.2819 5.86473L8.06867 1.61153C8.06047 1.60331 8.05006 1.59771 8.03872 1.59545C8.02739 1.59319 8.01565 1.59436 8.00497 1.59882C7.99429 1.60327 7.98516 1.61082 7.97872 1.6205C7.97228 1.63018 7.96881 1.64157 7.96877 1.65323V5.49238C7.96877 5.61788 8.01815 5.73824 8.10606 5.82698C8.19397 5.91573 8.31319 5.96558 8.43752 5.96558H12.2405C12.2521 5.96553 12.2634 5.96204 12.273 5.95554C12.2826 5.94903 12.29 5.93981 12.2944 5.92904C12.2989 5.91826 12.3 5.9064 12.2978 5.89496C12.2955 5.88352 12.29 5.873 12.2819 5.86473Z"
        fill="#4FD1C5"
      />
    </svg>
  );
};

export default IconDocs;
